import React, { Fragment, useEffect, useState, useMemo } from "react";
import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    Radio,
    RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    tableCellClasses,
    Checkbox,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import InputField from "components/Input";
import SystemServices from "services/System";
import ExportFinanceServices from "services/ExportFinance";
import DatePicker from "components/DatePicker";
import { CommaSeparator, allowedRolesForCash, numberRegex } from "utils";
import { Add, Delete } from "@mui/icons-material";
import styled from "@emotion/styled";
import SimpleDialog from "components/Dialog/SimpleDialog";
import { useSelector } from "react-redux";
import { getFileSize, CleanTypes } from "utils";
import UploadFile from "components/UploadFile";
import { v4 as uuidv4 } from "uuid";
import instance from "config/axios";
import routes from "services/System/routes";
import Uploading from "components/Uploading";
import { useAuth } from "context/UseContext";
import { SearchIcon } from "assets";
import { createRoot } from "react-dom/client";
import ReceiptVoucherInvoice from "components/erp_invoices/receipt_voucher";

// *For Upload File types
const allowFilesType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
];

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "center",
        whiteSpace: "nowrap",
        backgroundColor: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "center",
        textWrap: "nowrap",

        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));

function ReceiptVoucherV2() {
    const navigate = useNavigate();
    const { user, userLogout } = useAuth();
    const { usdExchangeRate } = useSelector((state) => state.navigationReducer);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        resetField,
    } = useForm();
    const {
        register: register2,
        handleSubmit: handleSubmit2,
        setValue: setValue2,
        resetField: resetField2,
    } = useForm();
    const { register: register3, handleSubmit: handleSubmit3 } = useForm();
    const [loading, setLoading] = useState(false);
    const [loadings, setLoadings] = useState(false);

    const [openRateDialog, setOpenRateDialog] = useState(false);
    const [openRateModal, setOpenRateModal] = useState(false);

    // *For Payment Method
    const [paymentMethod, setPaymentMethod] = useState("bank");

    // *For Bank Account
    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);

    // *For Cashier Account
    const [cashierAccounts, setCashierAccounts] = useState([]);
    const [selectedCashierAccount, setSelectedCashierAccount] = useState(null);

    // *For Vault Customer
    const [vaultCustomers, setVaultCustomers] = useState([]);
    const [selectedVaultCustomer, setSelectedVaultCustomer] = useState(null);

    // *For Customer Vault Accounts
    const [vaultAccounts, setVaultAccounts] = useState([]);
    const [selectedVaultAccount, setSelectedVaultAccount] = useState(null);

    // *For Handle Date
    const [vaultDate, setVaultDate] = useState(new Date());

    // *For Major Categories
    const [majorCategories, setMajorCategories] = useState([]);
    const [selectedMajorCategory, setSelectedMajorCategory] = useState(null);

    // *For Sub Categories
    const [subCategories, setSubCategories] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);

    // *For Parent Account
    const [parentAccounts, setParentAccounts] = useState([]);
    const [selectedParentAccount, setSelectedParentAccount] = useState(null);

    // *For Accounts
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    // *For Vault Unit
    const [vaultUnit, setVaultUnit] = useState();

    const [accountList, setAccountList] = useState([]);

    const [fcyAed, setFcyAed] = useState(0);
    const [fcyUsd, setFcyUsd] = useState(0);

    // *For Currency
    const [exchangeRateAed, setExchangeRateAed] = useState();
    const [exchangeRateUsd, setExchangeRateUsd] = useState();
    const [calculateRate, setCalculateRate] = useState();

    const [exchangeLoss, setExchangeLoss] = useState(0);
    const [newExchangeRateUsd, setNewExchangeRateUsd] = useState(0);

    const [isSearching, setIsSearching] = useState(false);
    const [filters, setFilters] = useState({});
    const [pageLimit, setPageLimit] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchData, setSearchData] = useState([]);
    const [path, setPath] = useState([]);

    // *For Remove Uploaded Document
    const removeDoc = () => {
        try {
            setDocumentDetail([]);
            setDocumentLink("");
            setValue("scanned", "");
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Uploaded Documents
    const [progress, setProgress] = useState(0);
    const [uploadedSize, setUploadedSize] = useState(0);
    const [documentDetail, setDocumentDetail] = useState([]);
    const [documentLink, setDocumentLink] = useState("");
    const [rowOpen, setRowOpen] = useState({});
    const [addedRows, setAddedRows] = useState([]);
    const [selectedItems, setSelectedItems] = useState({});
    const [addedItemIds, setAddedItemIds] = useState([]);

    const totalSelectedCount = useMemo(
        () => Object.keys(selectedItems).length,
        [selectedItems]
    );
    const addedCount = useMemo(() => addedItemIds.length, [addedItemIds]);

    const toggleCheckbox = (id) => {
        setSelectedItems((prev) => {
            const newSelectedItems = { ...prev };
            if (newSelectedItems[id]) {
                delete newSelectedItems[id];
            } else {
                newSelectedItems[id] = true;
            }
            return newSelectedItems;
        });
    };

    const toggleRow = (id) => setRowOpen((p) => ({ ...p, [id]: !p[id] }));

    useEffect(() => {
        if (totalSelectedCount === 0) {
            setSearchData([]);
            resetField2("search");
        }
    }, [selectedItems]);

    // *For Handle Date
    const handleVaultDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setVaultDate("invalid");
                return;
            }
            setVaultDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Upload Document
    const handleUploadDocument = async (e) => {
        try {
            e.preventDefault();
            const file = e.target.files[0];
            let arr = [
                {
                    id: uuidv4(),
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ];
            if (allowFilesType.includes(file.type)) {
                setDocumentDetail(arr);
                handleUpload(file, arr);
            } else {
                ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleUpload = async (file, docs) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress(percentCompleted);
                    setUploadedSize(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail(docs);
                setDocumentLink(data?.data?.nations);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Currencies
    const getCurrencies = async () => {
        try {
            let params = {
                detailed: true,
            };
            const { data } = await SystemServices.getCurrencies(params);
            setExchangeRateAed(
                parseFloat(
                    data?.currencies.find((e) => e.currency === "aed")?.conversion_rate
                )
            );
            setExchangeRateUsd(
                parseFloat(
                    data?.currencies.find((e) => e.currency === "usd")?.conversion_rate
                )
            );
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Banks
    const getBanks = async () => {
        try {
            let params = {
                page: 1,
                limit: 500,
            };
            const { data } = await ExportFinanceServices.getBanks(params);
            const activeBanks = data?.banks?.rows.filter(bank => bank.is_active);
            const bankArray = [];
            activeBanks
                .filter((e) => e.currency !== "cad")
                .forEach((e) => {
                    let obj = {
                        ...e,
                        name: e?.name + " " + e?.currency.toUpperCase(),
                    };
                    bankArray.push(obj);
                });
            setBankAccounts(bankArray);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Payment Accounts
    const getPaymentAccounts = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                name: search,
            };
            const { data } = await ExportFinanceServices.getPaymentAccounts(params);
            if (allowedRolesForCash.includes(user?.role_id)) {
                const userId = user?.id;
                setCashierAccounts(
                    data?.cashierAccounts?.rows.filter(
                        (e) => e.currency !== "cad" && e.user_id === userId
                    )
                );
            } else {
                const cashierDetail = data?.cashierAccounts?.rows.filter(
                    (e) => e.currency !== "cad"
                );
                setCashierAccounts(cashierDetail);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Vault Customers
    const getVaultCustomers = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                name: search,
            };
            const { data } = await ExportFinanceServices.getVaultCustomers(params);
            setVaultCustomers(data?.customers?.rows);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Sub Categories
    const getSubCategories = async (id) => {
        try {
            let params = {
                category_id: id ?? "",
            };
            const { data } = await ExportFinanceServices.getSubCategories(params);
            setSubCategories(data?.categories);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Major Categories
    const getMajorCategories = async () => {
        try {
            const { data } = await ExportFinanceServices.getMajorCategories();
            setMajorCategories(data?.categories);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Account By SubCategory
    const getAccountBySubCategory = async (id) => {
        try {
            let params = {
                sub_category: id,
            };
            const { data } = await ExportFinanceServices.getAccountBySubCategory(
                params
            );
            setParentAccounts(data?.accounts?.rows);
        } catch (error) {
            console.log("error:", error);
        }
    };

    // *For Get Account
    const getAccounts = async (search, accountId) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                name: search,
                primary_account_id: accountId ?? selectedParentAccount?.id,
            };
            const { data } = await ExportFinanceServices.getAccounts(params);
            setAccounts(data?.accounts?.rows);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Handle Add Received Detail
    const handleAddReceivedDetail = () => {
        const price = getValues("price");
        if (!price) {
            return;
        }
        const shallowCopy = [...accountList];
        if (paymentMethod === "bank") {
            const exRate =
                selectedBankAccount?.currency === "aed"
                    ? exchangeRateAed
                    : exchangeRateUsd;
            let unit = selectedAccount
                ? selectedAccount?.unit
                : selectedParentAccount?.unit;
            let obj = {
                id: selectedBankAccount?.id,
                name: selectedBankAccount?.name,
                fcy_amount: price,
                ex_rate: exRate,
                lcy_amount: parseFloat(price * exRate).toFixed(2),
                currency: selectedBankAccount?.currency,
                account_id:
                    unit === "Vehicle"
                        ? selectedBankAccount?.guc_account_id
                        : selectedBankAccount?.gwc_account_id,
            };
            shallowCopy.push(obj);
            if (selectedBankAccount?.currency === "aed") {
                let totalFcyAed = fcyAed;
                totalFcyAed += parseFloat(price);
                setFcyAed(totalFcyAed);
            } else {
                let totalFcyUsd = fcyUsd;
                totalFcyUsd += parseFloat(price);
                setFcyUsd(totalFcyUsd);
                const totalExchangeLoss =
                    totalFcyUsd * exchangeRateUsd - totalFcyUsd * exRate;
                setExchangeLoss(totalExchangeLoss);
            }
            setSelectedBankAccount(null);
        } else {
            const exRate =
                selectedCashierAccount?.currency === "aed"
                    ? exchangeRateAed
                    : exchangeRateUsd;
            let obj = {
                id: selectedCashierAccount?.id,
                name: selectedCashierAccount?.name,
                fcy_amount: price,
                ex_rate: exRate,
                lcy_amount: price * exRate,
                currency: selectedCashierAccount?.currency,
                account_id: selectedCashierAccount?.id,
            };
            shallowCopy.push(obj);
            if (selectedCashierAccount?.currency === "aed") {
                let totalFcyAed = fcyAed;
                totalFcyAed += parseFloat(price);
                setFcyAed(totalFcyAed);
            } else {
                let totalFcyUsd = fcyUsd;
                totalFcyUsd += parseFloat(price);
                setFcyUsd(totalFcyUsd);
                const totalExchangeLoss =
                    totalFcyUsd * exchangeRateUsd - totalFcyUsd * exRate;
                setExchangeLoss(totalExchangeLoss);
            }
            setSelectedCashierAccount(null);
        }
        setAccountList(shallowCopy);
        resetField("price");
    };

    const handleDelete = (index, amount, currency) => {
        const shallowCopy = [...accountList];
        shallowCopy.splice(index, 1);

        if (currency === "aed") {
            let totalFcyAed = fcyAed;
            totalFcyAed -= parseFloat(amount);
            setFcyAed(totalFcyAed);
        } else {
            let totalFcyUsd = fcyUsd;
            totalFcyUsd -= parseFloat(amount);
            setFcyUsd(totalFcyUsd);
        }

        setAccountList(shallowCopy);
        resetField("price");
    };

    // *For Create Receipt Voucher
    const ReceiptVoucher = async (formData) => {
        setLoading(true);
        try {
            const accDetail = [];
            const enterisDetail = [];

            accountList.forEach((e) => {
                let obj = {
                    fcy_amount: parseFloat(e?.fcy_amount)?.toFixed(2),
                    ex_rate: e?.ex_rate,
                    lcy_amount:
                        e?.ex_rate > 1
                            ? parseFloat(
                                e?.fcy_amount *
                                (calculateRate ? calculateRate : exchangeRateUsd)
                            )?.toFixed(2)
                            : parseFloat(e?.lcy_amount)?.toFixed(2),
                    currency: e?.currency,
                    account_id: e?.account_id,
                    ex_loss: parseFloat(exchangeLoss || 0)?.toFixed(2),
                    updated_ex_rate: calculateRate ? calculateRate : exchangeRateUsd,
                    received_ex_rate: newExchangeRateUsd
                        ? newExchangeRateUsd
                        : exchangeRateUsd,
                };
                if (paymentMethod === "bank") {
                    obj.bank_id = e?.id;
                    obj.bank_name = e?.name;
                } else if (paymentMethod === "cash") {
                    obj.bank_id = e?.id;
                    obj.bank_name = e?.name;
                }
                accDetail.push(obj);
            });

            addedRows.forEach((e) => {
                let obj = {
                    fcy_amount: parseFloat(e?.amount)?.toFixed(2),
                    receiver_vault: e?.id === null ? e?.parent_id : e?.id,
                    full_path: e?.full_path,
                    lcy_amount: parseFloat(e?.amount).toFixed(2),
                    description: sanitizeDescription(e?.description),
                };
                enterisDetail.push(obj);
            });

            let total = 0;
            addedRows.forEach((row) => {
                total += parseFloat(row?.amount) || 0;
            });

            let totalUsd = total / 3.675;
            const totalAmountAed = total;
            const totalAmountUsd = totalUsd;

            let obj = {
                customer_id: selectedVaultCustomer?.id,
                receiver_vault: selectedAccount
                    ? selectedAccount?.id
                    : selectedParentAccount?.id,
                remarks: formData?.remark,
                paid_to: formData?.paidTo,
                received_by: formData?.receivedBy,
                aed_total: parseFloat(totalAmountAed)?.toFixed(2),
                usd_total: parseFloat(totalAmountUsd)?.toFixed(2),
                payment_medium: paymentMethod,
                created_at: vaultDate,
                ex_loss: parseFloat(exchangeLoss || 0)?.toFixed(2),
                unit:
                    accounts.length > 0
                        ? selectedAccount?.unit
                        : selectedParentAccount?.unit,
                detail: accDetail,
                enteries: enterisDetail,
                document_link: documentLink,
                updated_ex_rate: calculateRate ? calculateRate : exchangeRateUsd,
                received_ex_rate: newExchangeRateUsd
                    ? newExchangeRateUsd
                    : exchangeRateUsd,
                new_voucher: true,
            };

            const result = await ExportFinanceServices.ReceiptVoucherV2(obj);

            if (result?.status === true && result?.responseCode === 200) {
                const voucher_id = result?.data?.id;
                const params = { voucher_id };

                // Fetch full invoice details
                const { data } = await ExportFinanceServices.getReceiptDetail(params);

                if (!data) {
                    console.log("No record found to upload");
                    return;
                }

                const uploadFiles = [];

                const file = await new Promise((resolve, reject) => {
                    try {
                        const container = document.createElement("div");
                        container.style.position = "absolute";
                        container.style.top = "-99999px";
                        container.style.left = "-99999px";
                        container.style.width = "1200px";
                        document.body.appendChild(container);

                        const root = createRoot(container);

                        const handleDone = (pdfBlob) => {
                            setTimeout(() => {
                                try {
                                    root.unmount();
                                    container.remove();
                                } catch (err) {
                                    console.error("❌ Cleanup Error", err);
                                }
                                resolve(pdfBlob);
                            }, 200);
                        };

                        root.render(
                            <ReceiptVoucherInvoice
                                receiptDetail={data?.voucher}
                                receiptAccountDetail={data?.voucher?.details}
                                onDone={handleDone}
                                v2={true}
                            />
                        );
                    } catch (err) {
                        console.error("❌ PDF Generation Error", err);
                        reject(err);
                    }
                });

                const pdfFile =
                    file instanceof Blob
                        ? new File([file], `receiptVoucherV2-GRV-${voucher_id}.pdf`, {
                            type: "application/pdf",
                        })
                        : null;

                uploadFiles.push({
                    voucher_id: voucher_id,
                    file: pdfFile,
                });

                const formData = new FormData();
                formData.append("invoice_type", "receiptVoucherV2");

                uploadFiles.forEach((file, index) => {
                    formData.append(`receipt_voucher[${index}][voucher_id]`, voucher_id);
                    formData.append(`receipt_voucher[${index}][file]`, file.file);
                });

                await SystemServices.uploadERPInvoices(formData);

                setLoading(false);
                SuccessToaster(result.message);
                navigate("/receipt-voucher-list-export");
                window.location.reload();
            }
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setLoading(false);
        }
    };

    const AED_PER_USD = 3.675;

    const totals = React.useMemo(() => {
        let totalAED = 0;
        let totalUSD = 0;

        for (const r of addedRows || []) {
            const amount = Number(r?.amount ?? 0);
            if (!amount || isNaN(amount)) continue;
            totalAED += amount;
            totalUSD += amount / AED_PER_USD;
        }

        return {
            aed: Number(totalAED.toFixed(2)),
            usd: Number(totalUSD.toFixed(2)),
        };
    }, [addedRows]);

    const accountTotals = React.useMemo(() => {
        let totalAED = 0;
        let totalUSD = 0;

        for (const r of accountList || []) {
            const amount = Number(r?.fcy_amount ?? 0);
            if (!amount || isNaN(amount)) continue;
            totalAED += amount;
            totalUSD += amount / AED_PER_USD;
        }

        return {
            aed: Number(totalAED.toFixed(2)),
            usd: Number(totalUSD.toFixed(2)),
        };
    }, [accountList]);

    const valTotal = (calculateRate
        ? fcyUsd * calculateRate +
        fcyAed * exchangeRateAed
        : fcyUsd * exchangeRateUsd +
        fcyAed * exchangeRateAed
    )?.toFixed(2)

    const isSubmitDisabled = !(
        Math.abs(parseFloat(valTotal).toFixed(2) - parseFloat(totals.aed).toFixed(2)) <= 0.05
    );

    const hasReceived = accountList.length > 0;
    const hasEntries = addedRows.length > 0;

    // *For Update Exchange Rate
    const updateExchangeRate = (formData) => {
        try {
            setNewExchangeRateUsd(formData?.rate);
            setOpenRateDialog(false);
            const accountUpdatedRate = [];
            accountList.forEach((element) => {
                const newExchangeRate =
                    element?.currency === "aed" ? element?.ex_rate : formData?.rate;
                let obj = {
                    ...element,
                    ex_rate: newExchangeRate,
                    lcy_amount: element?.fcy_amount * newExchangeRate,
                };
                accountUpdatedRate.push(obj);
            });
            setAccountList(accountUpdatedRate);

            const aedValue = (calculateRate
                ? fcyUsd * calculateRate + fcyAed * exchangeRateAed
                : fcyUsd * exchangeRateUsd + fcyAed * exchangeRateAed
            )?.toFixed(2);
            const totalExchangeLoss = (exchangeRateUsd - formData?.rate) * aedValue;
            setExchangeLoss(totalExchangeLoss / formData?.rate);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const updateExchangeRateUsd = (formData) => {
        try {
            setCalculateRate(formData?.usdRate);
            setOpenRateModal(false);
            const accountUpdatedRate = [];
            accountList.forEach((element) => {
                const newExchangeRate =
                    element?.currency === "aed" ? element?.ex_rate : formData?.usdRate;
                let obj = {
                    ...element,
                    ex_rate: newExchangeRate,
                    lcy_amount: element?.fcy_amount * newExchangeRate,
                };
                accountUpdatedRate.push(obj);
            });
            setAccountList(accountUpdatedRate);

            const totalExchangeLoss =
                fcyUsd * formData?.usdRate - fcyUsd * exchangeRateUsd;
        } catch (error) {
            ErrorToaster(error);
        }
    };

    useEffect(() => {
        getBanks();
        getMajorCategories();
        getSubCategories();
        getPaymentAccounts();
        getVaultCustomers();
        getCurrencies();
    }, []);

    useEffect(() => {
        setSelectedBankAccount(null);
        setSelectedCashierAccount(null);
        setAccountList([]);
        setFcyAed(0);
        setFcyUsd(0);
    }, [paymentMethod]);


    const getAccountsData = async (page, limit, filter) => {
        setLoadings(true);
        const Page = page ? page : currentPage;
        const Limit = limit ? limit : pageLimit;
        const Filter = { ...filters, ...filter };
        setCurrentPage(Page);
        setPageLimit(Limit);
        setFilters(Filter);

        try {
            let params = {
                page: Page,
                limit: Limit,
                excludeL2: true,
            };
            params = { ...params, ...Filter };

            const { data } = await ExportFinanceServices.getAccountsData(params);
            setSearchData(data?.accounts);
        } catch (error) {
            setLoadings(false);
            ErrorToaster(error);
        }
    };

    const stripHtml = (input = "") => {
        if (!input) return "";
        let out = input.replace(/<[^>]*>/g, "");
        out = out.replace(/on\w+="[^"]*"/gi, "");
        out = out.replace(/\r?\n+/g, " ").trim();
        return out;
    };

    const sqlBadPatterns = [
        /--/i,
        /;/,
        /\/\*|\*\//,
        /\bunion\s+select\b/i,
        /\bdrop\s+(table|database)\b/i,
        /\btruncate\s+table\b/i,
        /\binsert\s+into\b/i,
        /\bupdate\s+.*\s+set\b/i,
        /\bdelete\s+from\b/i,
        /\bxp_[_a-z]+\b/i,
        /\bsys\.[_a-z]+\b/i,
        /\bor\s+1\s*=\s*1\b/i,
    ];

    const MAX_DESC_LEN = 500;

    const sanitizeDescription = (input) => {
        const noHtml = stripHtml(input ?? "");
        const clipped = noHtml.slice(0, MAX_DESC_LEN);
        return clipped;
    };

    const hasSqlInjectionPattern = (input = "") =>
        sqlBadPatterns.some((re) => re.test(input));

    const validateSafeDescription = (value) => {
        const raw = value ?? "";
        const cleaned = sanitizeDescription(raw);
        if (!cleaned) return "Please enter a description.";
        if (hasSqlInjectionPattern(cleaned)) {
            return "Your description contains disallowed patterns.";
        }
        return true;
    };

    useEffect(() => {
        if (searchData) {
            const paths = searchData.map((item) => {
                return [
                    item?.cat?.name,
                    item?.sub_cat?.name,
                    item?.primary?.name,
                    item?.name,
                ]
                    .filter(Boolean)
                    .join(" → ");
            });

            setPath(paths);
        }
    }, [searchData]);

    const handleAddFromSearch = (item) => {
        const id = item.id;

        const exRate = item?.currency === "aed" ? exchangeRateAed : exchangeRateUsd;

        if (!selectedItems[id]) {
            return ErrorToaster("Please select the checkbox first.");
        }

        const fullPath = [
            item?.cat?.name,
            item?.sub_cat?.name,
            item?.primary?.name,
            item?.name,
        ]
            .filter(Boolean)
            .join(" → ");

        const exRatee = item?.currency === "aed" ? 1 : 3.675;

        const row = {
            row_key: Date.now() + Math.random(),
            id,
            parent_id: item?.primary_account_id,
            full_path: fullPath,
            account_code: item?.account_code || "",
            description: "",
            amount: 0,
        };

        setAddedRows((prev) => {
            const count = prev.filter((r) => r.id === id).length;

            if (count >= 5) {
                ErrorToaster("You can add this item only 5 times.");
                return prev;
            }

            return [...prev, row];
        });

        setSelectedItems((prev) => {
            const newSelectedItems = { ...prev };
            delete newSelectedItems[id];
            return newSelectedItems;
        });

        setAddedItemIds((prev) => [...prev, id]);

        SuccessToaster("Added.");

        if (totalSelectedCount === 0 || Object.keys(selectedItems).length === 0) {
            setSearchData([]);
            resetField2("search");
        }
    };

    const filteredCashierAccounts = cashierAccounts.filter((e) => {
        const isNameMatch = e?.name
            .toLowerCase()
            .includes(user?.name.toLowerCase());
        const isCurrencyAed = e?.currency === "aed";
        return isCurrencyAed;
    });

    const removeAddedRow = (row_key) => {
        setAddedRows((prev) => prev.filter((row) => row.row_key !== row_key));
    };

    const updateAddedRow = (row_key, patch) =>
        setAddedRows((prev) =>
            prev.map((r) => (r.row_key === row_key ? { ...r, ...patch } : r))
        );

    const handleFilter = async (data) => {
        const q = (data?.search ?? "").trim();
        if (!q) {
            setSearchData([]);
            setLoadings(false);
            return;
        }

        setLoadings(true);
        if (isSearching) return;

        setIsSearching(true);
        try {
            await getAccountsData(1, "", { search: q });
        } catch (err) {
            console.error("Search failed:", err);
        } finally {
            setIsSearching(false);
            setLoadings(false);
        }
    };

    return (
        <Box
            sx={{
                m: 4,
                p: 5,
                bgcolor: Colors.white,
                borderRadius: 3,
                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
            }}
        >
            <SimpleDialog
                open={openRateDialog}
                onClose={() => setOpenRateDialog(false)}
                title={"Update Exchange Rate"}
            >
                <Box component="form" onSubmit={handleSubmit2(updateExchangeRate)}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12}>
                            <InputField
                                size={"small"}
                                label={"Exchange Rate"}
                                placeholder={"Exchange Rate"}
                                defaultValue={exchangeRateUsd}
                                register={register2("rate", {
                                    required: "Please enter make.",
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
                            <PrimaryButton title="Save" type="submit" />
                        </Grid>
                    </Grid>
                </Box>
            </SimpleDialog>
            <SimpleDialog
                open={openRateModal}
                onClose={() => setOpenRateModal(false)}
                title={"Update Exchange Rate"}
            >
                <Box component="form" onSubmit={handleSubmit3(updateExchangeRateUsd)}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12}>
                            <InputField
                                size={"small"}
                                label={"Exchange Rate"}
                                placeholder={"Exchange Rate"}
                                defaultValue={exchangeRateUsd}
                                register={register3("usdRate", {
                                    required: "Please enter make.",
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
                            <PrimaryButton title="Save" type="submit" />
                        </Grid>
                    </Grid>
                </Box>
            </SimpleDialog>

            <Box component="form" onSubmit={handleSubmit(ReceiptVoucher)}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Typography
                            variant="h5"
                            sx={{
                                color: Colors.charcoalGrey,
                                fontFamily: FontFamily.NunitoRegular,
                                mb: 4,
                            }}
                        >
                            Create Receipt Voucher V2
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={2.6} display="flex">
                        <Typography color="black" mt={2} mr={1} fontSize="18px">
                            Date
                        </Typography>
                        <DatePicker
                            size={"small"}
                            value={vaultDate}
                            onChange={(date) => handleVaultDate(date)}
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={2.6}>
                        <InputField
                            size={"small"}
                            placeholder={"Received By"}
                            register={register("receivedBy")}
                            inputStyle={{
                                width: "100%",
                                wordWrap: "break-word",
                                whiteSpace: "pre-wrap",
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5.2}>
                        <InputField
                            size={"small"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                            placeholder={"Search"}
                            register={register2("search", {
                                onChange: (e) => handleFilter({ search: e.target.value }),
                            })}
                        />
                    </Grid>

                    {searchData?.length > 0 && (
                        <>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        mt: 1,
                                        border: "1px solid #E5E7EB",
                                        borderRadius: 2,
                                        overflow: "hidden",
                                    }}
                                >
                                    {searchData.map((item, index) => {
                                        const open = !!rowOpen[item.id];
                                        const pathForItem = path[index];
                                        const isChecked = selectedItems[item.id] || false;
                                        return (
                                            <Box
                                                key={item.id}
                                                sx={{
                                                    display: "grid",
                                                    alignItems: "center",
                                                    gridTemplateColumns: {
                                                        xs: isChecked
                                                            ? "100px 1fr 0.5fr 0.9fr 0.5fr"
                                                            : "auto 1fr",
                                                        sm: isChecked
                                                            ? "100px 1.3fr 0.7fr 1fr 0.5fr"
                                                            : "auto 1fr",
                                                        md: isChecked
                                                            ? "100px 1.4fr 0.7fr 1fr 0.5fr"
                                                            : "auto 1fr",
                                                    },
                                                    columnGap: { xs: 1, sm: 1, md: 1 },
                                                    px: { xs: 0.5, sm: 1 },
                                                    py: 1,
                                                    borderBottom: "1px solid #F1F5F9",
                                                    "&:last-child": { borderBottom: 0 },
                                                }}
                                            >
                                                <FormControlLabel
                                                    sx={{ m: 0 }}
                                                    control={
                                                        <Checkbox
                                                            checked={isChecked}
                                                            onChange={() => toggleCheckbox(item.id)}
                                                            sx={{ p: 0.5 }}
                                                        />
                                                    }
                                                    label=""
                                                />

                                                <Tooltip title={pathForItem} arrow>
                                                    <Typography
                                                        sx={{
                                                            minWidth: 0,
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        {pathForItem}
                                                    </Typography>
                                                </Tooltip>

                                                <Box
                                                    sx={{ display: "flex", justifyContent: "flex-end" }}
                                                >
                                                    {isChecked && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleAddFromSearch(item)}
                                                            sx={{
                                                                bgcolor: Colors.primary,
                                                                color: Colors.white,
                                                                "&:hover": {
                                                                    bgcolor: Colors.primary,
                                                                    color: Colors.white,
                                                                },
                                                            }}
                                                        >
                                                            <Add />
                                                        </IconButton>
                                                    )}
                                                </Box>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Grid>
                        </>
                    )}

                    {addedRows.length > 0 && (
                        <>
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        mt: 0.5,
                                        border: "1px solid #E5E7EB",
                                        borderRadius: 2,
                                        overflow: "hidden",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "grid",
                                            gridTemplateColumns: "45% 15% 30% 10%",
                                            gap: 2,
                                            px: 1.5,
                                            py: 1,
                                            bgcolor: Colors.primary,
                                            color: "#ffff",
                                            borderBottom: "1px solid #EEF2F7",
                                            fontWeight: 700,
                                            fontSize: 12,
                                        }}
                                    >
                                        <Typography>Full Path</Typography>
                                        <Typography sx={{ textAlign: "right" }}>Amount</Typography>
                                        <Typography>Description</Typography>
                                        <Typography>Action</Typography>
                                        <Typography />
                                    </Box>

                                    {addedRows.map((r) => (
                                        <Box
                                            key={r.row_key}
                                            sx={{
                                                display: "grid",
                                                gridTemplateColumns: "45% 15% 30% 10%",
                                                gap: 2,
                                                px: 1.5,
                                                py: 1,
                                                borderBottom: "1px solid #F1F5F9",
                                                "&:last-child": { borderBottom: 0 },
                                            }}
                                        >
                                            <Tooltip title={r.full_path} arrow>
                                                <Typography
                                                    sx={{
                                                        mt: 2,
                                                        minWidth: 0,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    {r.full_path}
                                                </Typography>
                                            </Tooltip>

                                            <Typography sx={{ textAlign: "right", fontSize: "14px" }}>
                                                <InputField
                                                    size="small"
                                                    placeholder="0.00"
                                                    value={r.amount ?? ""}
                                                    fullWidth
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                AED
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    register={register(`searchRows.${r.id}.amount`, {
                                                        pattern: /^[0-9]*(\.[0-9]{0,2})?$/,
                                                        onChange: (e) => {
                                                            let v = e.target.value;
                                                            v = v.replace(/,/g, "");

                                                            if (v !== "" && Number(v) <= 0) {
                                                                ErrorToaster("Amount must be greater than 0.");
                                                                return;
                                                            }

                                                            if (v === "" || /^[0-9]*(\.[0-9]{0,2})?$/.test(v)) {
                                                                updateAddedRow(r.row_key, { amount: v });
                                                            }
                                                        }
                                                    })}
                                                />
                                            </Typography>

                                            <Tooltip title={r.description} arrow>
                                                <Typography
                                                    sx={{
                                                        minWidth: 0,
                                                        whiteSpace: "normal",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    <InputField
                                                        size="small"
                                                        placeholder="Description"
                                                        fullWidth
                                                        multiline
                                                        value={r.description ?? ""}
                                                        onChange={(e) => {
                                                            updateAddedRow(r.row_key, {
                                                                description: e.target.value,
                                                            });
                                                        }}
                                                        onBlur={(e) => {
                                                            const cleaned = sanitizeDescription(
                                                                e.target.value
                                                            );
                                                            updateAddedRow(r.row_key, {
                                                                description: cleaned,
                                                            });
                                                        }}
                                                    />
                                                </Typography>
                                            </Tooltip>

                                            <Box sx={{ mt: 2 }}>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => removeAddedRow(r.row_key)}
                                                >
                                                    <Delete
                                                        sx={{
                                                            color: Colors.danger,
                                                            height: "20px !important",
                                                        }}
                                                    />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "70% 30%",
                                        gap: 2,
                                        px: 1.5,
                                        py: 1,
                                        borderBottom: "1px solid #EEF2F7",
                                        fontWeight: 700,
                                        fontSize: 12,
                                    }}
                                >
                                    <Typography>Total</Typography>
                                    <Typography>
                                        {CommaSeparator(totals.aed.toFixed(2))} AED
                                    </Typography>
                                </Box>
                            </Grid>
                        </>
                    )}

                    <Grid item xs={12} sm={3}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                color: Colors.charcoalGrey,
                                fontFamily: FontFamily.NunitoRegular,
                            }}
                        >
                            Payment Method
                        </Typography>
                        <FormControl>
                            <RadioGroup
                                row
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                            >
                                <Tooltip
                                    title={
                                        allowedRolesForCash.includes(user?.role_id)
                                            ? ""
                                            : "This option is only for Cashier"
                                    }
                                    arrow
                                    placement="top"
                                >
                                    <span style={{ display: "inline-block" }}>
                                        <FormControlLabel
                                            value="cash"
                                            control={<Radio />}
                                            label="Cash"
                                            disabled={!allowedRolesForCash.includes(user?.role_id)}
                                            sx={{
                                                "& .Mui-disabled": {
                                                    opacity: 0.5,
                                                },
                                            }}
                                        />
                                    </span>
                                </Tooltip>
                                <FormControlLabel
                                    value="bank"
                                    control={<Radio />}
                                    label="Bank"
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4}>
                        <Typography
                            variant="body1"
                            sx={{ color: Colors.charcoalGrey, mb: 1 }}
                        >
                            Attach File
                        </Typography>
                        <UploadFile
                            custom={true}
                            style={{
                                backgroundColor: "#e7efeb",
                                width: "100%",
                                height: "40px",
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "20px",
                                border: "1px dashed #aeb1b0",
                                borderRadius: "10px",
                            }}
                            error={errors?.scanned?.message}
                            register={register("scanned", {
                                onChange: (e) => handleUploadDocument(e),
                            })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        {documentDetail.length > 0 && (
                            <Typography
                                variant="body1"
                                sx={{ color: Colors.charcoalGrey, mb: 1 }}
                            >
                                Uploaded Files
                            </Typography>
                        )}
                        <Box sx={{ maxHeight: 300, overflow: "auto", pr: 1 }}>
                            {documentDetail?.map((item, index) => (
                                <Uploading
                                    key={index}
                                    data={item}
                                    uploadedSize={uploadedSize}
                                    progress={progress}
                                    removeDoc={() => removeDoc()}
                                />
                            ))}
                        </Box>
                    </Grid>

                    {Array.isArray(addedRows) && addedRows.length > 0 ? (
                        <Fragment>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <Box sx={{ p: 1 }}>
                                        <Typography variant="subtitle1">
                                            {paymentMethod === "bank" ? "Bank" : "Cashier"} A/c
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            gap: "5px",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Box sx={{ width: "250px" }}>
                                            {paymentMethod === "bank" && (
                                                <SelectField
                                                    size={"small"}
                                                    options={bankAccounts}
                                                    selected={selectedBankAccount}
                                                    onSelect={(value) =>
                                                        setSelectedBankAccount(value)
                                                    }
                                                    register={register("bank")}
                                                />
                                            )}

                                            {paymentMethod === "cash" &&
                                                allowedRolesForCash.includes(user?.role_id) && (
                                                    <SelectField
                                                        size={"small"}
                                                        onSearch={(v) => getPaymentAccounts(v)}
                                                        options={filteredCashierAccounts}
                                                        selected={selectedCashierAccount}
                                                        onSelect={(value) =>
                                                            setSelectedCashierAccount(value)
                                                        }
                                                        register={register("cash")}
                                                    />
                                                )}
                                        </Box>
                                        <Box sx={{ width: "150px" }}>
                                            <InputField
                                                size={"small"}
                                                placeholder={"Amount"}
                                                register={register("price", {
                                                    pattern: numberRegex,
                                                    onChange: (e) => {
                                                        let priceAmount = e.target.value;
                                                        priceAmount = priceAmount.replace(/,/g, "");
                                                        if (
                                                            priceAmount === "" ||
                                                            /^[0-9]*\.?[0-9]{0,2}$/.test(priceAmount)
                                                        ) {
                                                            setValue("price", priceAmount);
                                                        }
                                                    },
                                                })}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            {paymentMethod == "cash"
                                                                ? selectedCashierAccount?.currency == "usd"
                                                                    ? "USD"
                                                                    : "AED"
                                                                : paymentMethod == "bank"
                                                                    ? selectedBankAccount?.currency == "usd"
                                                                        ? "USD"
                                                                        : "AED"
                                                                    : ""}
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ width: "50px" }}>
                                            <IconButton
                                                size="small"
                                                onClick={() => handleAddReceivedDetail()}
                                                sx={{
                                                    bgcolor: Colors.primary,
                                                    color: Colors.white,
                                                    "&:hover": {
                                                        bgcolor: Colors.primary,
                                                        color: Colors.white,
                                                    },
                                                }}
                                            >
                                                <Add />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                    {accountList?.length > 0 && (
                                        <Box>
                                            <TableContainer
                                                component={Paper}
                                                sx={{
                                                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                                    borderRadius: 2,
                                                }}
                                            >
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <Cell>
                                                                {paymentMethod === "bank" ? "Bank" : "Cashier"}{" "}
                                                                A/C
                                                            </Cell>
                                                            <Cell>Amount</Cell>
                                                            <Cell>Status</Cell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {accountList.map((item, index) => (
                                                            <Row
                                                                key={index}
                                                                sx={{
                                                                    bgcolor: index % 2 !== 0 && "#EEFBEE",
                                                                }}
                                                            >
                                                                <Cell>{item?.name ?? "-"}</Cell>
                                                                <Cell>
                                                                    {CommaSeparator(
                                                                        parseFloat(item?.fcy_amount).toFixed(2)
                                                                    ) ?? "-"}
                                                                </Cell>
                                                                <Cell>
                                                                    <Box sx={{ gap: "16px !important" }}>
                                                                        <Box
                                                                            onClick={() =>
                                                                                handleDelete(
                                                                                    index,
                                                                                    item?.fcy_amount,
                                                                                    item?.currency
                                                                                )
                                                                            }
                                                                        >
                                                                            <IconButton
                                                                                sx={{
                                                                                    bgcolor: Colors.danger,
                                                                                    "&:hover": {
                                                                                        bgcolor: Colors.danger,
                                                                                    },
                                                                                }}
                                                                            >
                                                                                <Delete
                                                                                    sx={{
                                                                                        color: Colors.white,
                                                                                        height: "16px !important",
                                                                                    }}
                                                                                />
                                                                            </IconButton>
                                                                        </Box>
                                                                    </Box>
                                                                </Cell>
                                                            </Row>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    )}
                                    <Box
                                        mt={
                                            accountList.length > 2
                                                ? 2
                                                : accountList.length > 0
                                                    ? 8
                                                    : 12
                                        }
                                    >
                                        <InputField
                                            size={"small"}
                                            label={"Remark"}
                                            placeholder={"Remark"}
                                            rows={3}
                                            multiline
                                            register={register("remark")}
                                            inputStyle={{
                                                width: "100%",
                                                wordWrap: "break-word",
                                                whiteSpace: "pre-wrap",
                                            }}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Box>
                                        <Box sx={{ mb: 2, mt: 8 }}>
                                            <Box sx={{ p: 1 }}>
                                                <Typography variant="subtitle1">
                                                    Received Amount
                                                </Typography>
                                            </Box>
                                            <TableContainer
                                                component={Paper}
                                                sx={{
                                                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                                    borderRadius: 2,
                                                }}
                                            >
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <Cell>AED</Cell>
                                                            <Cell>Ex. Rate</Cell>
                                                            <Cell>USD</Cell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <Row>
                                                            <Cell>
                                                                {CommaSeparator(
                                                                    (calculateRate
                                                                        ? fcyUsd * calculateRate +
                                                                        fcyAed * exchangeRateAed
                                                                        : fcyUsd * exchangeRateUsd +
                                                                        fcyAed * exchangeRateAed
                                                                    )?.toFixed(2)
                                                                )}
                                                            </Cell>
                                                            <Cell
                                                                sx={{
                                                                    cursor: accountList?.length > 0 ? "pointer" : "not-allowed",
                                                                }}
                                                                onClick={() => {
                                                                    if (accountList?.length > 0) setOpenRateDialog(true);
                                                                }}
                                                            >
                                                                {accountList?.length > 0 ? (
                                                                    <Box
                                                                        sx={{
                                                                            textAlign: "center",
                                                                            p: 1,
                                                                            border: "1px solid #B2B5BA",
                                                                            borderRadius: "4px",
                                                                        }}
                                                                    >
                                                                        {parseFloat(
                                                                            newExchangeRateUsd
                                                                                ? newExchangeRateUsd
                                                                                : exchangeRateUsd
                                                                        )?.toFixed(3)}
                                                                    </Box>
                                                                ) : (
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            textAlign: "center",
                                                                            color: "#B2B5BA",
                                                                            fontStyle: "italic",
                                                                        }}
                                                                    >
                                                                        Locked Till Add Amount
                                                                    </Typography>
                                                                )}
                                                            </Cell>
                                                            <Cell>
                                                                {calculateRate
                                                                    ? CommaSeparator(
                                                                        parseFloat((fcyUsd * calculateRate +
                                                                            fcyAed * exchangeRateAed) /
                                                                            (newExchangeRateUsd
                                                                                ? newExchangeRateUsd
                                                                                : exchangeRateUsd)
                                                                        ).toFixed(2))
                                                                    : newExchangeRateUsd
                                                                        ? (
                                                                            (fcyAed * exchangeRateAed +
                                                                                fcyUsd * exchangeRateUsd) /
                                                                            newExchangeRateUsd
                                                                        )?.toFixed(2)
                                                                        : CommaSeparator(
                                                                            parseFloat((
                                                                                (fcyAed * exchangeRateAed +
                                                                                    fcyUsd * exchangeRateUsd) /
                                                                                exchangeRateUsd
                                                                            )?.toFixed(2))
                                                                        )}
                                                            </Cell>
                                                        </Row>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>

                                        <Box sx={{ p: 1 }}>
                                            <Typography variant="subtitle1">
                                                Received Currency Detail
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <TableContainer
                                                component={Paper}
                                                sx={{
                                                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                                    borderRadius: 2,
                                                }}
                                            >
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <Cell>Currency</Cell>
                                                            <Cell>FCY Amt</Cell>
                                                            <Cell>Ex.Rate</Cell>
                                                            <Cell>LCY</Cell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <Row>
                                                            <Cell>AED</Cell>
                                                            <Cell>{CommaSeparator(fcyAed?.toFixed(2))}</Cell>
                                                            <Cell>
                                                                {CommaSeparator(exchangeRateAed?.toFixed(2))}
                                                            </Cell>
                                                            <Cell>
                                                                {CommaSeparator(
                                                                    (fcyAed * exchangeRateAed)?.toFixed(2)
                                                                )}
                                                            </Cell>
                                                        </Row>
                                                        <Row>
                                                            <Cell>USD</Cell>
                                                            <Cell>{CommaSeparator(fcyUsd?.toFixed(2))}</Cell>

                                                            <Cell
                                                                sx={{ cursor: "pointer" }}
                                                                onClick={() => setOpenRateModal(true)}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        textAlign: "center",
                                                                        p: 1,
                                                                        border: "1px solid #B2B5BA",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                >
                                                                    {CommaSeparator(parseFloat(
                                                                        calculateRate || exchangeRateUsd
                                                                    )?.toFixed(3))}
                                                                </Box>
                                                            </Cell>
                                                            <Cell>
                                                                {CommaSeparator(
                                                                    (calculateRate
                                                                        ? fcyUsd * calculateRate
                                                                        : fcyUsd * exchangeRateUsd
                                                                    )?.toFixed(2)
                                                                )}
                                                            </Cell>
                                                        </Row>
                                                        <Row>
                                                            <Cell colspan={2}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{ fontWeight: 700 }}
                                                                    textAlign={"left"}
                                                                    ml={3}
                                                                >
                                                                    Total in AED
                                                                </Typography>
                                                            </Cell>
                                                            <Cell colspan={2}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{ fontWeight: 700 }}
                                                                    textAlign={"right"}
                                                                    mr={3}
                                                                >
                                                                    {CommaSeparator(
                                                                        (calculateRate
                                                                            ? fcyUsd * calculateRate +
                                                                            fcyAed * exchangeRateAed
                                                                            : fcyUsd * exchangeRateUsd +
                                                                            fcyAed * exchangeRateAed
                                                                        )?.toFixed(2)
                                                                    )}
                                                                </Typography>
                                                            </Cell>
                                                        </Row>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Box>
                                    </Box>
                                    <Box sx={{ mt: 2 }}>
                                        <Box sx={{ p: 1 }}>
                                            <Typography variant="subtitle1">Exchange Loss</Typography>
                                        </Box>
                                        <TableContainer
                                            component={Paper}
                                            sx={{
                                                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                                borderRadius: 2,
                                            }}
                                        >
                                            <Table stickyHeader>
                                                <TableHead>
                                                    <TableRow>
                                                        <Cell>GWS Rate</Cell>
                                                        <Cell>Ex. Loss</Cell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <Row>
                                                        <Cell>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{ fontWeight: 700 }}
                                                            >
                                                                Ex. Loss / Gain
                                                            </Typography>
                                                        </Cell>
                                                        <Cell>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{ fontWeight: 700 }}
                                                            >
                                                                {CommaSeparator(
                                                                    parseFloat(exchangeLoss || 0).toFixed(2)
                                                                )}
                                                            </Typography>
                                                        </Cell>
                                                    </Row>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Fragment>
                    ) : (
                        <Fragment></Fragment>
                    )}
                    <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
                        <PrimaryButton
                            title="Submit"
                            type="submit"
                            loading={loading}
                            disabled={isSubmitDisabled || !hasReceived || !hasEntries}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default ReceiptVoucherV2;